import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DateInput, NumberInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"
import { checkDateSet } from "data/lib/dates"

import { FormError_s } from "styles/form-styles"
import { MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const AreaDetailed = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyItem = {
    date: null,
    area: null
  }

  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }})) : [{...emptyItem, i: 0}]);
  const [data, setData] = useState<object|null>({...props.rowData[props.field]})
  const [homogenous, setHomogenous] = useState<boolean>(true);

  function updateVal(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data)
    if(items[field[0]][field[1]] === val) return
    items[field[0]][field[1]] = val
    if (field[1] === 'date') {
      let dateModeCheck = checkDateSet(val, items)
      setHomogenous(dateModeCheck.homogenous)
      _.set(newData, 'dateMode', dateModeCheck.dateMode)
    }
    setData(newData)
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed')
    props.persist(newData, 'areadetail', props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let newData = _.cloneDeep(data)
    let dateModeCheck = checkDateSet(items[0]?.['date'], items)
    setHomogenous(dateModeCheck.homogenous)
    _.set(newData, 'dateMode', dateModeCheck.dateMode)
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'detailed'){
      _.set(newData, 'state', 'detailed')
    }
    props.persist(newData, 'areadetail', props.rowData)
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateVal
  }

  useEffect(() => {
    if (_.get(props['rowData'][props.field], "state") !== 'detailed'){
      setItems([{...emptyItem, i: 0}]);
      setData({})
    } else {
      setData({...props.rowData[props.field]});
    }
  }, [props['rowData']])

  const item_attrs = (field) => field_attrs('rentroll', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      { renderItems.map((row:object, i) => (
        <MultiRowCarouselState_s className="carousel-multi-row">
          <div>
            { i === 0 && <label>Date</label> }
            <DateInput 
              className="automated date-allow-relative" 
              attrs={item_attrs} 
              field={[`${row['i']}`, 'date']} 
              {...params} 
              allowRelative 
            />
          </div>
          <div>
            { i === 0 && <label>Area</label> }
            <NumberInput 
              className="automated billion-input" 
              attrs={item_attrs} 
              field={[`${row['i']}`, 'area']} 
              {...params} 
              readPrecision={0} 
              writePrecision={0} 
              min={0} 
              max={1000000000} 
            />
          </div>
          <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={items} />
        </MultiRowCarouselState_s>
      ))}
      {!homogenous && <FormError_s>All dates must be either relative or absolute</FormError_s>}
    </div>
  )
}

export default AreaDetailed
